import React, { useState } from "react";
import "./Register.css";
import StepForm from "./stepform/StepForm";
import { Link } from "react-router-dom";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Register() {
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <section className="Register">
      <div className="container">
        {/* <Link to={"/"}>
        <div className="back_to_home_holder">
          <FontAwesomeIcon className="home_icon" icon={faHouse} />
        </div>
        </Link> */}
        {/* Show logo for steps 1–4 only */}
        {currentStep < 5 && (
          <div className="img_holder">
            <Link to="/">
              <img
                src="/assets/images/logo/logo.png"
                alt="logo"
                className="logo_img"
              />
          </Link>
            </div>
        )}

        {/* Heading logic based on step */}
        {currentStep < 5 && (
          <div className="heading_text_holder">
            {currentStep === 3 || currentStep === 4 ? (
              <h3>
                PICK YOUR PERFECT <b>SUBSCRIPTION</b>.
              </h3>
            ) : (
              <h3>
                <b>REGISTER</b> TO CONTINUE YOUR JOURNEY.
              </h3>
            )}
          </div>
        )}

        {/* Step Form */}
        <StepForm setCurrentStep={setCurrentStep} />
      </div>
    </section>
  );
}

export default Register;
